import { render } from "./DatePicker.vue?vue&type=template&id=e8c755ea"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"
script.render = render

export default script